export enum EventContainerMovementWorkspaceCapabilityAccessOperation {
    read = "b96b533a-a97c-4482-9a97-5ba2d8859144",
    preview = "fc778227-6d56-4da6-8055-ea9f0c87a873",
    execute = "25544892-119d-461b-8250-6970d9f710bf",
    export = "128b584a-dd84-4461-bfc2-c8e0ea2fefde",
}
